// src/assets/data/cursos/cripto-blockchain/modulo-2.js
import banner from "../../../courses/module-2/img2.png";

const modulo2 = {
  courseId: "cripto-blockchain",
  id: "modulo-2",
  title: "🧩 MÓDULO 2: Blockchain para principiantes",
  estimatedDuration: "1 hora 30 minutos",
  format: "Lectura + actividad de verificación",
  bannerUrl: banner,
  sections: [
    {
      id: "objetivos",
      navLabel: "Objetivos",
      title: "🎯 Objetivo del módulo",
      content: [
        "Entender qué es blockchain (cadena de bloques), cómo se validan las transacciones dentro de esta tecnología, y por qué esta base es tan importante para el funcionamiento del mundo Web3.",
      ],
    },
    {
      id: "definicion",
      navLabel: "¿Qué es blockchain?",
      title: "🔍 ¿Qué es una cadena de bloques (blockchain)?",
      content: [
        {
          type: "paragraph",
          text: "Una blockchain es como un registro digital gigante, público y compartido. Imagina una libreta de apuntes donde cada página es un bloque, y todas las páginas están unidas una tras otra, formando una cadena.",
        },
        {
          type: "paragraph",
          text: "En lugar de estar guardada en una sola computadora o en un banco, esta libreta está distribuida en miles de computadoras (llamadas nodos) en todo el mundo. Todos tienen una copia idéntica.",
        },
        {
          type: "paragraph",
          text: "Cada vez que alguien hace una operación (como enviar una criptomoneda), esa acción se escribe en la siguiente página del libro (un bloque). Una vez escrita y verificada, nadie puede borrarla ni cambiarla.",
        },
        {
          type: "paragraph",
          text: "📌 ¿Qué tipo de información puede contener una blockchain?",
        },
        {
          type: "list",
          items: [
            "Transacciones financieras (pagos en criptomonedas)",
            "Propiedad de objetos digitales (NFT, coleccionables)",
            "Contratos inteligentes",
            "Datos de identificación o historial médico",
          ],
        },
      ],
    },
    {
      id: "transaccion",
      navLabel: "Transacción",
      title: "🔁 ¿Cómo funciona una transacción en blockchain?",
      content: [
        "Aquí va un ejemplo paso a paso, explicado con una historia sencilla:",
        {
          type: "orderedList",
          items: [
            "Ana quiere enviarle 10 USDC (Nota1) a Diego.",
            "Usa su wallet para crear la transacción.",
            "La transacción se envía a la red blockchain.",
            "Los nodos verifican saldo y firma digital.",
            "Se agrupa en un nuevo bloque.",
            "El bloque se valida y se añade a la cadena.",
            "Diego recibe los 10 USDC en su wallet.",
          ],
        },
        "Nota1 -> “USDC es una criptomoneda estable (stablecoin) parecida al dólar digital.”",
        {
          type: "paragraph",
          text: "🧠 ¿Qué hace que esto sea tan seguro?",
        },
        {
          type: "list",
          items: [
            "Todos los bloques tienen un código único (como una huella digital).",
            "Ese código depende del contenido del bloque y del bloque anterior.",
            "Si alguien intenta cambiar una sola letra de un bloque, el código cambia y la red lo rechaza.",
          ],
        },
      ],
    },
    {
      id: "descentralizacion",
      navLabel: "Descentralización",
      title: "🤝 ¿Qué es descentralización?",
      content: [
        {
          type: "paragraph",
          text: "Descentralizar significa que no hay una sola empresa o persona controlando todo.",
        },
        {
          type: "paragraph",
          text: "En una blockchain, todas las personas que participan en la red ayudan a mantenerla viva y segura.",
        },
        {
          type: "paragraph",
          text: "🧠 Comparación:",
        },
        {
          type: "list",
          items: [
            "En un banco tradicional, tus datos están en los servidores de esa empresa.",
            "En blockchain, los datos están repartidos entre miles de usuarios, que se vigilan entre sí para que nadie haga trampa.",
          ],
        },
      ],
    },
    {
      id: "consenso",
      navLabel: "Consenso",
      title: "🔐 ¿Qué es el consenso?",
      content: [
        {
          type: "paragraph",
          text: "Cuando una nueva transacción aparece, la red necesita ponerse de acuerdo para decidir si es válida.",
        },
        {
          type: "paragraph",
          text: "A este proceso se le llama mecanismo de consenso.",
        },
        {
          type: "paragraph",
          text: "🔄 Dos formas comunes de llegar al consenso:",
        },
        {
          type: "table",
          headers: ["Método", "¿Cómo funciona?", "Ejemplo"],
          rows: [
            [
              "Proof of Work",
              "Nodos compiten resolviendo acertijos matemáticos",
              "Bitcoin",
            ],
            [
              "Proof of Stake",
              "Quien más monedas tiene, más probabilidad de validar",
              "Ethereum (hoy), Solana",
            ],
          ],
        },
        {
          type: "paragraph",
          text: "🧠 Dato curioso: En Proof of Stake, cuanto más confía la red en ti (porque tienes más monedas o buena reputación), más probabilidades tienes de validar un bloque y ganar recompensas.",
        },
      ],
    },
    {
      id: "ejemplos",
      navLabel: "Ejemplos reales",
      title: "🏢 Ejemplos del mundo real",
      content: [
        {
          type: "orderedList",
          items: [
            "IBM + Maersk: usan blockchain para rastrear contenedores en barcos. Esto reduce fraudes y errores en logística internacional.",
            "Visa + Stellar: están trabajando juntos para permitir pagos internacionales más baratos y rápidos usando blockchain.",
            "Hospitales: se están probando blockchains para guardar historiales médicos, evitando que se pierdan o alteren.",
          ],
        },
      ],
    },
    {
      id: "videos",
      navLabel: "Videos",
      title: "📺 Videos recomendados",
      content: [
        {
          type: "link",
          href: "https://www.youtube.com/watch?v=Yn8WGaO__ak",
          text: "🎥 ¿Qué es Blockchain? – Cripto en Minutos",
        },
      ],
    },
    {
      id: "lecturas",
      navLabel: "Lecturas complementarias",
      title: "📚 Lecturas complementarias",
      content: [
        {
          type: "link",
          href: "https://academy.binance.com/es/articles/what-is-blockchain-and-how-does-it-work",
          text: "Binance Academy – ¿Cómo funciona blockchain?",
        },
        {
          type: "link",
          href: "https://es.cointelegraph.com/learn/articles/how-does-blockchain-work-a-beginners-guide-to-blockchain-technology",
          text: "Cointelegraph – Guía de blockchain para principiantes",
        },
      ],
    },
    {
      id: "actividad",
      navLabel: "Actividad",
      title: "✅ Actividad de verificación",
      content: [
        "Título: El ciclo de vida de una transacción en blockchain",
        {
          type: "paragraph",
          text: "Instrucciones:",
        },
        {
          type: "paragraph",
          text: "Crea un pequeño esquema visual en Google Docs donde expliques los 7 pasos desde que una persona inicia una transacción hasta que se valida en la cadena.",
        },
      ],
    },
    {
      id: "frase",
      navLabel: "Frase del día",
      title: "🧠 Frase del día",
      content: [
        "“Blockchain no es solo tecnología. Es confianza digital construida por miles de personas.”",
      ],
    },
  ],
};

export default modulo2;
